



































































import Vue from 'vue';

import { InstallationsPanels } from '@/components';
import InstallationsLegend from '@/components/installations-legend';
import ServiceDayCard from '@/components/service/ServiceDayCard.vue';

import moment, { Moment } from 'moment';
import { debounce } from 'underscore';
import { MechanicInstallation, Pagination, ServiceAssignment } from '@/types';

moment.locale('nl');

export default Vue.extend({
  components: {
    InstallationsLegend,
    InstallationsPanels,
    ServiceDayCard,
  },

  data() {
    return {};
  },

  computed: {
    date(): Moment {
      return moment(this.$store.getters['installations/selectedDate']);
    },

    totalPanels(): number {
      return this.installations.reduce((total, installation) => {
        if (installation.modules.some(i => i.type === 'METER_MAAS-REGULAR')) return total;

        return installation.screening.numberOfPanels + total;
      }, 0);
    },

    monitoringOnly(): number {
      return this.installations.filter(installation =>
        installation.modules.some(i => i.type === 'METER_MAAS-REGULAR'),
      ).length;
    },

    slopedRoofs(): number {
      return this.installations.filter(
        installation =>
          !installation.modules.some(i => i.type === 'METER_MAAS-REGULAR') &&
          installation.screening.panelsLocation !== 'plat',
      ).length;
    },

    flatRoofs(): number {
      return this.installations.filter(
        installation => installation.screening.panelsLocation === 'plat',
      ).length;
    },

    currentDate(): string {
      return this.date.calendar(undefined, {
        sameDay: '[Vandaag] - D MMMM YYYY',
        nextDay: '[Morgen] - D MMMM YYYY',
        nextWeek: 'dddd - D MMMM YYYY',
        lastDay: '[Gisteren] - D MMMM YYYY',
        lastWeek: 'dddd - D MMMM YYYY',
        sameElse: 'dddd - D MMMM YYYY',
      });
    },

    isFetching(): boolean {
      return this.$store.getters['installations/isPending'];
    },

    page(): Pagination<MechanicInstallation> {
      return (
        this.$store.getters['installations/installations']() || {
          data: [],
          meta: {
            total: 0,
          },
        }
      );
    },

    installations(): MechanicInstallation[] {
      return this.page.data.slice().sort((a, b) => {
        // First regular installations, then monitoring only
        if (a.modules.length > b.modules.length) return -1;
        else if (b.modules.length > a.modules.length) return 1;

        // Then sort by installation date/time
        if (a.installationDate > b.installationDate) return 1;
        else if (b.installationDate > a.installationDate) return -1;

        return 0;
      });
    },

    total(): number {
      return this.page.meta.total;
    },

    serviceAssignments(): ServiceAssignment[] {
      return this.$store.getters['service/byDate'](this.date.valueOf());
    },
  },

  created() {
    this.$store.commit('installations/setDate', Date.now());
    this.fetch();
    // The service list isn't date-scoped (filtered client-side by day), so fetch it once.
    this.$store.dispatch('service/fetch:list');
  },

  methods: {
    nextDay() {
      this.date.add(1, 'day');
      this.$store.commit('installations/setDate', this.date.valueOf());
      this.fetch();
    },

    previousDay() {
      this.date.subtract(1, 'day');
      this.$store.commit('installations/setDate', this.date.valueOf());
      this.fetch();
    },

    fetch: debounce(function(this: Vue) {
      this.$store.dispatch('installations/fetch:byDate');
    }, 500),
  },
});
